<template>
  <div>电缆桥架</div>
</template>
<script>
import { BridgeModelApi } from '@wiz-api/huizhou2-business'

const bridgeModelApi = new BridgeModelApi()

export default {
  name: 'bridgeCable',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {
    async setRootModelShow(show) {
      const root = await this.player.Native.ModelTree.getRootItems()
      const rootList = root.map((val) => {
        return val.item
      })
      this.player.Native.ModelTree.setItemVisible(rootList, show)
      // const { data } = await this.cloudRender.Model.getAllInfo()
      // this.cloudRender.NodeProxy.setNodeVisible(data[0].dataInfo.nodeInstance, false)
    },
    async init() {
      const [err, res] = await bridgeModelApi.getList({
        sceneId: this.sourceId,
        skipCount: 0, // Number |
        maxResultCount: 999, // Number |
      })
      if (!err) {
        const params = []
        res.items.forEach((item) => {
          params.push({
            code: item.code,
          })
        })
        await this.setRootModelShow(false)
        const codeRes = await this.player.Native.ModelTree.batchFindItemByCode(params)
        const visibleList = []
        codeRes.forEach((resItem) => {
          visibleList.push(resItem.item)
        })
        this.player.Native.ModelTree.setItemVisible(visibleList, true)
        this.initCamera(visibleList)
      }
    },
    async initCamera(items) {
      const aabbRes = await this.player.Native.ModelTree.batchCalcItemAabb(items)
      const finalAabb = [[0, 0, 0], [0, 0, 0]]
      aabbRes.forEach((item) => {
        finalAabb[0] = this.calcAabb(item.aabb.max, finalAabb[0], 'max')
        finalAabb[1] = this.calcAabb(item.aabb.min, finalAabb[1], 'min')
      })
      this.player.Native.Camera.moveToAabbWithDistance(finalAabb, 1, 4, 0.5)
    },
    calcAabb(itemAabb, finalAabb, type) {
      const res = finalAabb
      if (type === 'max') {
        if (res[0] < itemAabb[0]) {
          res[0] = itemAabb[0]
        }
        if (res[1] < itemAabb[1]) {
          res[1] = itemAabb[1]
        }
        if (res[2] < itemAabb[2]) {
          res[2] = itemAabb[2]
        }
      } else {
        if (res[0] > itemAabb[0]) {
          res[0] = itemAabb[0]
        }
        if (res[1] > itemAabb[1]) {
          res[1] = itemAabb[1]
        }
        if (res[2] > itemAabb[2]) {
          res[2] = itemAabb[2]
        }
      }
      return res
    },
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    this.setRootModelShow(true)
  },
}
</script>
